import { StyleSheet } from 'aphrodite';
import { brandPrimaryHover, nameCircles } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	closeButton: {
		marginLeft: -20,
		paddingBottom: 8,
	},
	container: {},
	fileArea: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	fileContainer: {
		alignItems: 'center',
		background: '#EDEDED',
		boxSizing: 'border-box',
		color: brandPrimaryHover,
		display: 'inline-flex',
		fontSize: 12,
		marginRight: 4,
		padding: '4px 10px',
	},
	image: {
		borderRadius: 8,
		width: '93%',
	},
	imageArea: {
		display: 'flex',
		flex: 1,
		height: '100%',
		maxWidth: 240,
		padding: 8,
	},
	imageAreaContainer: {
		background: 'white',
		border: `1px solid ${nameCircles}`,
		borderBottom: 0,
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		borderTopLeftRadius: THEME.common.borderRadius,
		borderTopRightRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		gap: THEME.spacing.xs,
	},
	attachmentPreviewsRow: {
		alignItems: 'flex-end',
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
		...CssSelectors.allChildren(
			{
				marginLeft: -20,
			},
			':not(:first-child)'
		),
	},
	messageInput: {
		fontSize: 16,
		paddingRight: 8,
	},
	messageInputContainer: {
		background: '#fff',
	},
	previewContainer: {
		display: 'flex',
		height: '100%',
		padding: 2,
	},
	sendMessageBtn: {
		':focus-visible': {
			outline: `1px dashed ${brandPrimaryHover}`,
			outlineOffset: 2,
			...CssSelectors.allChildren(
				{
					fill: brandPrimaryHover,
				},
				'svg > path'
			),
		},
		padding: 0,
	},
	sizeWarning: {
		textAlign: 'center',
	},
	textArea: {
		':focus-visible': {
			border: 'none',
			outline: 'none',
		},
		border: 'none',
		overflowY: 'hidden',
		resize: 'none',
		width: '95%',
		wordWrap: 'break-word',
	},
	textAreaContainer: {
		background: 'white',
		border: `1px solid ${nameCircles}`,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		justifyContent: 'space-between',
		padding: 10,
	},
	textAreaWithImages: {
		borderTop: `1px solid ${nameCircles}`,
		borderTopLeftRadius: 0,
		borderTopRightRadius: 0,
		paddingTop: 8,
	},
	toolbar: {
		alignItems: 'flex-end',
		paddingBottom: 5,
	},
	toolbarButtonsContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		minWidth: 40,
	},
	transparentBtn: {
		background: 'none',
		border: 'none',
		outlone: 'none',
	},
	sendAsLinkRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	sendAsLinkLabel: {
		color: THEME.colors.text.main,
		cursor: 'pointer',
		fontSize: THEME.typography.fontSizes.sm,
	},
	sendAsLinkWarning: {
		color: THEME.colors.warning.main,
		fontSize: THEME.typography.fontSizes.xs,
		margin: 0,
		paddingBottom: THEME.spacing.xs,
	},
	fileLinksContent: {
		minWidth: 180,
	},
	fileLinksTrigger: {
		height: 'auto',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		fontSize: THEME.typography.fontSizes.sm,
		border: 'none',
		boxShadow: 'none',
		outline: 'none',
		backgroundColor: 'transparent',
		cursor: 'pointer',
	},
});
